import PropTypes from "prop-types";
import { childrenPropType } from "../../common";

/**
 * PropTypes for Sidebar component
 *
 * @property {React.ReactNode} [children] - Sidebar content
 * @property {boolean} [isOpen] - Sidebar open/closed state
 * @property {function} [onToggle] - Toggle handler callback
 * @property {Array<{label: string, path: string, icon?: React.ReactNode}>} [items] - Navigation items
 * @property {string} [activeItem] - Currently active item path
 */
export const sidebarPropTypes = {
  children: childrenPropType,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      icon: PropTypes.node,
    })
  ),
  activeItem: PropTypes.string,
};
